import React from 'react';
import { motion } from 'framer-motion';

const AvisoLegal = () => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-neutral-900 text-neutral-300 py-32 px-6 md:px-12"
    >
      <div className="max-w-3xl mx-auto">
        
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-12 tracking-tighter">
          Aviso Legal
        </h1>
        
        {/* Contenedor del texto con espaciado amplio para facilitar la lectura */}
        <div className="space-y-10 leading-relaxed">
          
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Datos del Titular y Fiscales</h2>
            <p className="mb-4">
              En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se exponen a continuación los datos identificativos del titular del sitio web <strong>firststudio.es</strong>:
            </p>
            <ul className="list-none space-y-3 text-neutral-400 bg-neutral-800/50 p-6 rounded-lg border border-neutral-800">
              <li><strong className="text-white">Titular:</strong> Javier Barroso González</li>
              <li><strong className="text-white">NIF / CIF:</strong> 79083760P</li>
              <li><strong className="text-white">Domicilio:</strong> Santa Cruz de Tenerife, Tenerife (España).</li>
              <li><strong className="text-white">Correo electrónico:</strong> contacto@firststudio.es</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Condiciones de Uso</h2>
            <p className="mb-4">
              El acceso y uso del sitio web <strong>firststudio.es</strong> otorga la condición de Usuario, e implica la aceptación total y sin reservas de todas las disposiciones incluidas en este Aviso Legal. 
            </p>
            <p>
              El Usuario se compromete a hacer un uso adecuado y lícito del sitio web y de sus contenidos, de conformidad con la legislación aplicable, el presente Aviso Legal, la moral y las buenas costumbres generalmente aceptadas y el orden público. Queda expresamente prohibido el uso de la web con fines ilícitos o lesivos contra First Studio o cualquier tercero.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Propiedad Intelectual e Industrial</h2>
            <p className="mb-4">
              First Studio, por sí mismo o como cesionario, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma. Esto incluye, a título enunciativo y no limitativo: textos, imágenes, diseño gráfico, código fuente, logotipos, marcas, combinaciones de colores y animaciones.
            </p>
            <p>
              Cualquier reproducción, distribución, comunicación pública o transformación de la totalidad o parte de los contenidos de esta web, con fines comerciales, en cualquier soporte y por cualquier medio técnico, sin la autorización expresa de First Studio, queda terminantemente prohibida.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Legislación Aplicable y Jurisdicción</h2>
            <p>
              Las relaciones establecidas entre First Studio y el Usuario se regirán por la normativa española vigente. Para la resolución de cualquier controversia o disputa que pudiera surgir en relación con el acceso o uso de este sitio web, ambas partes se someten expresamente a los Juzgados y Tribunales de <strong>Santa Cruz de Tenerife</strong>, renunciando a cualquier otro fuero que pudiera corresponderles.
            </p>
          </section>

        </div>
      </div>
    </motion.div>
  );
};

export default AvisoLegal;
